var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidepanelEmptySecuritygroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2241 48.3119L24.4401 43.5599L49.0801 57.7919L40.8721 62.5359L16.2241 48.3119Z",
    fill: "url(#paint0_linear_2548_296507)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9277 26.3199C48.8307 26.1525 48.6931 26.0122 48.5277 25.9119L47.6477 25.3999L24.8637 12.2479C24.8065 12.2067 24.7398 12.1807 24.6699 12.1723C24.5999 12.1639 24.5289 12.1734 24.4637 12.1999L16.3757 16.8639C16.2877 16.9199 18.1037 39.8799 18.1037 39.8799L21.5437 42.1119L49.0077 26.4799C48.9859 26.4243 48.9591 26.3707 48.9277 26.3199Z",
    fill: "url(#paint1_linear_2548_296507)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9277 49.9601C48.9914 49.9199 49.0425 49.8626 49.075 49.7946C49.1076 49.7267 49.1203 49.6509 49.1117 49.5761V26.9121C49.1067 26.7625 49.0713 26.6156 49.0077 26.4801L21.5437 42.1121L40.8397 54.6241L48.9277 49.9601Z",
    fill: "url(#paint2_linear_2548_296507)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9277 49.9601C48.9914 49.9199 49.0425 49.8626 49.075 49.7946C49.1076 49.7267 49.1203 49.6509 49.1117 49.5761V26.9121C49.1067 26.7625 49.0713 26.6156 49.0077 26.4801L21.5437 42.1121L40.8397 54.6241L48.9277 49.9601Z",
    fill: "url(#paint3_linear_2548_296507)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5037 25.12C37.5159 25.239 37.5593 25.3528 37.6295 25.4497C37.6998 25.5466 37.7943 25.6233 37.9037 25.672C38.2029 25.8219 38.533 25.9 38.8677 25.9C39.2024 25.9 39.5325 25.8219 39.8317 25.672C39.9406 25.6215 40.0343 25.5432 40.1032 25.4448C40.172 25.3465 40.2136 25.2316 40.2237 25.112V14.616C40.2237 10.304 36.9037 5.01597 32.6557 2.55997C30.2557 1.15197 27.8557 0.959973 26.0797 1.93597C24.5597 2.80797 23.6797 4.48797 23.6797 6.64797V17.2C23.6905 17.3205 23.7333 17.4359 23.8036 17.5343C23.8739 17.6327 23.9692 17.7106 24.0797 17.76C24.3775 17.9098 24.7063 17.9879 25.0397 17.9879C25.3731 17.9879 25.7019 17.9098 25.9997 17.76C26.1092 17.7093 26.2036 17.631 26.2737 17.5329C26.3439 17.4347 26.3873 17.32 26.3997 17.2V6.64797C26.356 6.19842 26.4287 5.74518 26.6108 5.33186C26.793 4.91854 27.0784 4.55905 27.4397 4.28797C28.3037 3.79197 29.7437 4.02397 31.2957 4.91997C34.6637 6.86397 37.5037 11.32 37.5037 14.616V25.12Z",
    fill: "url(#paint4_linear_2548_296507)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4484 30.576L39.5684 30.072L16.8004 16.912C16.7449 16.8636 16.6756 16.8339 16.6024 16.827C16.5291 16.8201 16.4555 16.8363 16.3919 16.8734C16.3283 16.9105 16.278 16.9666 16.248 17.0337C16.2179 17.1009 16.2097 17.1758 16.2244 17.248V39.912C16.2325 40.1221 16.2959 40.3263 16.4084 40.504C16.5026 40.6708 16.6374 40.8112 16.8004 40.912L39.5684 54.072L40.4484 54.576C40.504 54.6172 40.5694 54.6433 40.6381 54.6517C40.7068 54.6601 40.7765 54.6506 40.8404 54.624C40.9035 54.5851 40.9542 54.5291 40.9868 54.4626C41.0194 54.396 41.0324 54.3216 41.0244 54.248V31.576C41.0128 31.376 40.9547 31.1814 40.8547 31.0078C40.7547 30.8342 40.6156 30.6864 40.4484 30.576Z",
    fill: "url(#paint5_linear_2548_296507)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4002 33.304C30.3651 32.6794 30.1839 32.0718 29.8713 31.5299C29.5587 30.9881 29.1233 30.5271 28.6002 30.184C27.6002 29.608 26.7922 30.08 26.7922 31.224C26.8221 31.9409 27.0551 32.6345 27.4642 33.224L26.7922 37.472L30.4002 39.552L29.7282 34.536C29.957 34.4291 30.1455 34.2519 30.2664 34.0303C30.3873 33.8086 30.4342 33.5542 30.4002 33.304Z",
    fill: "url(#paint6_linear_2548_296507)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1277 30.808C41.0018 30.5956 40.8261 30.4172 40.6157 30.288L39.7357 29.784L16.9437 16.624L16.8637 16.584L16.3757 16.864C16.4203 16.8521 16.4672 16.8521 16.5117 16.864C16.6029 16.8658 16.6917 16.8935 16.7677 16.944L39.5677 30.072L40.4477 30.576C40.6091 30.6788 40.7435 30.8187 40.8397 30.984C40.8397 30.984 40.8797 31.056 40.9037 31.096L41.1917 30.928L41.1277 30.808Z",
    fill: "url(#paint7_linear_2548_296507)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2548_296507",
    x1: 22.3841,
    y1: 58.9759,
    x2: 42.9201,
    y2: 47.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2548_296507",
    x1: 13.8637,
    y1: 32.5439,
    x2: 42.8557,
    y2: 15.8079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2548_296507",
    x1: 22.8717,
    y1: 12.8081,
    x2: 47.1037,
    y2: 54.7761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2548_296507",
    x1: 21.5437,
    y1: 40.5521,
    x2: 49.1117,
    y2: 40.5521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2548_296507",
    x1: 684.943,
    y1: 796.976,
    x2: 684.943,
    y2: 41.6262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2548_296507",
    x1: 19.6644,
    y1: 35.744,
    x2: 41.2964,
    y2: 35.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2548_296507",
    x1: 26.1762,
    y1: 36.368,
    x2: 31.0562,
    y2: 33.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2548_296507",
    x1: 16.4877,
    y1: 16.68,
    x2: 42.1597,
    y2: 31.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDFDFD",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBFBFB",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7F7F7",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3F3F3",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EDEDED",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E6E6E6",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#DFDFDF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D6D6D6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidepanelEmptySecuritygroup);
export default __webpack_public_path__ + "static/media/sidepanel_empty_securitygroup.e36999aa84661aae73ec502054938b8a.svg";
export { ForwardRef as ReactComponent };